(function () {
  /**
   * @ngdoc module
   * @name app.core.country
   * @description Module which defines the Country constants
   */
  angular.module('app.core.country', []);
})();
